import {
  ADD_NEW_PROJECT,
  ADD_NEW_SUBMISSION,
  CLOSE_MODAL,
  EDIT_PROFILE,
  EDIT_SUBMISSION,
  UPDATE_PROJECT
} from '@/store/actions/modals'

const state = {
  modalsVisibility: {
    profile: false,
    project: false,
    submission: false
  },
  currentModels: {
    project: {},
    submission: {}
  }
}
const getters = {
  profileModalShown: state => state.modalsVisibility.profile,
  projectModalShown: state => state.modalsVisibility.project,
  submissionModalShown: state => state.modalsVisibility.submission,
  areAllModalsHidden: state => Object
    .values(state.modalsVisibility)
    .every(modal => !modal),
  currentProject: state => state.currentModels.project,
  currentSubmission: state => state.currentModels.submission
}

const mutations = {
  changeModalVisibility (state, { model, value }) {
    state.modalsVisibility[model] = value
  },
  setCurrentModalModel (state, { model, value }) {
    state.currentModels[model] = value
  }
}

const actions = {
  [ADD_NEW_PROJECT] ({ commit }) {
    commit('changeModalVisibility', {
      model: 'project',
      value: true
    })
  },
  [ADD_NEW_SUBMISSION] ({ commit }, { project }) {
    commit('changeModalVisibility', {
      model: 'submission',
      value: true
    })
    commit('setCurrentModalModel', {
      model: 'project',
      value: project
    })
    commit('setCurrentModalModel', {
      model: 'submission',
      value: {}
    })
  },
  [CLOSE_MODAL] ({ commit }, model) {
    commit('changeModalVisibility', {
      model,
      value: false
    })
  },
  [EDIT_SUBMISSION] ({ commit }, { submission }) {
    commit('changeModalVisibility', {
      model: 'submission',
      value: true
    })
    commit('setCurrentModalModel', {
      model: 'submission',
      value: submission
    })
  },
  [EDIT_PROFILE] ({ commit }) {
    commit('changeModalVisibility', {
      model: 'profile',
      value: true
    })
  },
  [UPDATE_PROJECT] ({ commit }, { value }) {
    commit('setCurrentModalModel', {
      model: 'project',
      value
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
